module.exports = __webpack_public_path__ + "static/media/a.f0c6978b.svg";